import { skipToken } from "@reduxjs/toolkit/dist/query";
import {
  PortalEventContextType,
  PortalInviteStatusDto,
  PortalLifecycleStatus,
  useGetPortalNegotiationRoundsQuery,
  type PortalNegotiationRoundDto,
  type PortalSourcingEventDetailDto,
} from "../../../../autogen/bff-api";
import { useAppSelector } from "../../../../common/redux/hooks";
import { roundAcceptsBids } from "./roundAcceptsBids";

const isParticipating = (event: PortalSourcingEventDetailDto): boolean =>
  event.myInviteStatus != null &&
  event.myInviteStatus !== PortalInviteStatusDto.NotInvited &&
  event.myInviteStatus !== PortalInviteStatusDto.Declined;

export const portalEventMayHaveRounds = (event: PortalSourcingEventDetailDto): boolean => {
  const isPrivate = event.contextType === PortalEventContextType.Private;
  const isActive = event.lifecycle.status !== PortalLifecycleStatus.Cancelled;
  return isActive && (!isPrivate || isParticipating(event));
};

export interface OpenPortalRound {
  round: PortalNegotiationRoundDto | null;
  isLoading: boolean;
}

export const useOpenPortalRound = (event: PortalSourcingEventDetailDto): OpenPortalRound => {
  const authState = useAppSelector((state) => state.authState.state);
  const relevant = authState?.type === "LoggedInWithOrgContext" && portalEventMayHaveRounds(event);
  const { data, isLoading } = useGetPortalNegotiationRoundsQuery(relevant ? { eventId: event.id } : skipToken);
  return {
    round:
      (data?.rounds ?? [])
        .filter((round) => roundAcceptsBids(round) && round.isCallerInvited)
        .sort((a, b) => a.roundNumber - b.roundNumber)
        .at(-1) ?? null,
    isLoading: relevant && isLoading,
  };
};
